import { lazyPage } from '@/lib/lazy-load'

const MyReferralPage = lazyPage(() => import('./MyReferralPage'))
export default MyReferralPage
